module.exports = __webpack_public_path__ + "img/debora-mirabal-byn.64858854.jpg";